import { render } from "./PaymentSuccess.vue?vue&type=template&id=5bf6d746&scoped=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"

import "./PaymentSuccess.vue?vue&type=style&index=0&id=5bf6d746&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf6d746"]])

export default __exports__